module.exports = __webpack_public_path__ + "media/images/loading-2299ad0b.gif";